export default __webpack_public_path__ + "static/media/user-blue.a031dfb8.svg";